import React, { Component } from 'react';
import { browserHistory } from 'react-router';
// import { Link } from 'react-router';
import { connect } from 'react-redux';
import { ProfileMenu } from '../../components'; //Modal
import './Header.scss';
//HEADERBAR ICON

class Header extends Component {

  constructor() {
    super();
    this.state = {
      hideShowDrp: false,
      un: '',
      planUse: 0,
      iu: '',
      activity: [],
      isFound: false,
      unSeenCount: 0,
      openClose: false,
      isVerify: true,
      fullName: '',
      menuIu: '',
      isSubMenu: false,
      //isShow: true
    };
  }

  handleDropdown = () => {
    this.setState({ hideShowDrp: !this.state.hideShowDrp });
  }

  componentDidMount = () => {

  }

  handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    localStorage.removeItem('e');
    localStorage.removeItem('pvd');
    localStorage.removeItem('WIDNM');
    localStorage.removeItem('WIDTP');
    localStorage.removeItem('WIDSHP');

    localStorage.removeItem('restoreId');
    localStorage.removeItem('ti');
    localStorage.removeItem('csub');
    localStorage.removeItem('istm');
    localStorage.removeItem('role');
    localStorage.removeItem('isbusr');//white_label
    localStorage.removeItem('utyp');
    localStorage.removeItem('isAppsumo');
    localStorage.removeItem('alg');
    localStorage.removeItem('fvicn');
    localStorage.removeItem('isMaster');
    localStorage.removeItem('isPixelIns');
    localStorage.removeItem('is_hide_blackfriday');
    localStorage.removeItem('loginTime');
    localStorage.removeItem('UTM_SIGNUP');
    localStorage.removeItem('rdt_url');

    window.location.href = process.env.REACT_APP_ROUTE_PREFIX + 'login';
  }

  hideShowMenu = () => {
    let mainDiv = document.getElementById('main-div');
    if (mainDiv.className == 'main sm-maincontent') {
      mainDiv.className = 'main lg-navigation';
      let sideDiv = document.getElementById('side-menu');
      sideDiv.className = 'left side-menu lg-maincontent';
    }
    else {
      mainDiv.className = 'main sm-maincontent';
      let sideDiv = document.getElementById('side-menu');
      sideDiv.className = 'left side-menu  sm-navigation';
    }
  }

  //close Modal
  closeModal = () => {
    this.setState({ openClose: false });
  }

  //hideShowOption 
  hideShowOption = () => {
    this.state.isSubMenu = !this.state.isSubMenu;
    this.setState(this.state);
  }

  //create notification
  createWidget = () => {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type');
  }

  render() {
    return (
      <div className="header-container" id="header-div">
        <div className="header-toolbar">
          {/* <div className="toolbar-left pull-left">
            <div className="layout-name notification-live-count">
              <h2 id="noti_page_name"></h2>
              <h4 id="noti_Name"></h4>
              <h2 id="page_name"></h2>
            </div>
          </div> */}



          <div className="toolbar-right pull-right">
            <ul className="tb-nav-list">

              <li style={{ display: 'none' }}>
                {/* onClick={() => this.handleSupport()} */}
                <div className="btn-add-notification btn-infoweb" id=''>
                  {
                    localStorage.getItem('pvd') == 'shopify' ?
                      <svg className={this.props.profile && this.props.profile.blid ? '' : 'blink'} xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                        <g id="Group_306" data-name="Group 306" transform="translate(-297 -389)">
                          <path id="Path_190" data-name="Path 190" d="M310.428,388a12.428,12.428,0,1,0,12.428,12.428A12.469,12.469,0,0,0,310.428,388Zm1.244,21.131h-2.489v-2.489h2.489Zm2.608-9.571-1.115,1.117a3.862,3.862,0,0,0-1.493,3.477h-2.489v-.618a4.505,4.505,0,0,1,1.493-3.477l1.493-1.62a2.083,2.083,0,0,0,.747-1.735,2.489,2.489,0,0,0-4.977,0h-2.481a4.97,4.97,0,1,1,9.939,0,4.536,4.536,0,0,1-1.117,2.857Zm0,0"
                            transform="translate(-1 1)" fill="#3C4858" />
                        </g>
                      </svg>
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                        <g id="Group_306" data-name="Group 306" transform="translate(-297 -389)">
                          <path id="Path_190" data-name="Path 190" d="M310.428,388a12.428,12.428,0,1,0,12.428,12.428A12.469,12.469,0,0,0,310.428,388Zm1.244,21.131h-2.489v-2.489h2.489Zm2.608-9.571-1.115,1.117a3.862,3.862,0,0,0-1.493,3.477h-2.489v-.618a4.505,4.505,0,0,1,1.493-3.477l1.493-1.62a2.083,2.083,0,0,0,.747-1.735,2.489,2.489,0,0,0-4.977,0h-2.481a4.97,4.97,0,1,1,9.939,0,4.536,4.536,0,0,1-1.117,2.857Zm0,0"
                            transform="translate(-1 1)" fill="#3C4858" />
                        </g>
                      </svg>
                  }
                </div>
              </li>

              <li className="header-btn-addnoti">
                <div className="btn-add-notification add-notification-tour">
                  <div>
                    <span className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-min15x pull-right" onClick={() => this.createWidget()}>
                      Add Wall
                    </span>
                    <div className="notifition-add-icon" onClick={() => this.createWidget()}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 448 448" width="100%">
                        <path fill="#6E87FF" d="m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0" />
                      </svg>
                    </div>
                  </div>
                </div>
              </li>

              <li id='hideProfile' style={{ display: 'none' }}>
                <ProfileMenu
                  iu={this.state.iu}
                  userInfo={this.props.profile}
                  planUse={this.state.planUse}
                  handleLogout={this.handleLogout}
                  fullName={this.state.fullName}
                  menuIu={this.state.menuIu}
                  profile={this.props.profile}
                  hideShowOption={this.hideShowOption}
                />
              </li>

              <li style={{ display: 'none' }}>
                <div className="nf-dropdown header-notification-dropdown" >
                  {/* onClick={() => this.handleDropdownNotif()} */}
                  <a id="dLabel" data-target="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" >
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="20" height="25" viewBox="0 0 30.117 37.794">
                      <defs>
                        <clipPath id="clip-path">
                          <rect id="Rectangle_1" data-name="Rectangle 1" width="30.117" height="37.794" fill="#3c4858" />
                        </clipPath>
                      </defs>
                      <g id="bell-icon" transform="translate(-153 -204)">
                        <path id="Path_1" data-name="Path 1" d="M252.906,553.359a5.709,5.709,0,0,0,10.451,0Zm0,0" transform="translate(-90.073 -314.974)" fill="#3c4858" />
                        <g id="Group_3" data-name="Group 3" transform="translate(153 204)">
                          <g id="Group_2" data-name="Group 2" clipPath="url(#clip-path)">
                            <path id="Path_2" data-name="Path 2" d="M265.833,207.611a12.846,12.846,0,0,1,4.385.768v-.169a4.215,4.215,0,0,0-4.21-4.21h-.349a4.215,4.215,0,0,0-4.21,4.21v.166a12.873,12.873,0,0,1,4.384-.766Zm0,0" transform="translate(-250.775 -204)" fill="#3c4858" />
                            <path id="Path_3" data-name="Path 3" d="M182.641,289.564H154.963a1.128,1.128,0,0,1-1.112-.865,1.076,1.076,0,0,1,.592-1.224,5.876,5.876,0,0,0,1.787-2.43c1.54-3.254,1.863-7.838,1.863-11.11a10.708,10.708,0,0,1,21.416-.043c0,.014,0,.028,0,.043,0,3.272.323,7.856,1.863,11.11a5.876,5.876,0,0,0,1.787,2.43,1.076,1.076,0,0,1,.592,1.224,1.128,1.128,0,0,1-1.112.865Zm.532-2.082h0Zm0,0" transform="translate(-153.744 -257.398)" fill="#3c4858" />
                          </g>
                        </g>
                      </g>
                    </svg>
                    {/* {
                      this.state.isFound === true &&
                      <span className="header-noti-circle">{this.state.unSeenCount}</span>
                    } */}
                  </a>
                  {/* {
                    this.state.activity.length > 0 ?
                      <ul className={this.state.hideShowNotif ? 'nf-dropdownbox nf-header-notifi nf-header-notif-ul' : 'nf-dropdownbox-close nf-dropdownbox nf-header-notifi nf-header-notif-ul'}>
                        {
                          this.state.activity.map((a, i) => {
                            return (
                              <li key={i}>
                                <Link to={a.rc} onClick={() => this.clickActivity(a._id, a.ic)}>{a.m}</Link>
                              </li>
                            );
                          })
                        }
                      </ul>
                      :
                      <div className={this.state.hideShowNotif ? 'nf-dropdownbox' : 'nf-dropdownbox-close nf-dropdownbox'}>
                        <span>No activity found.</span>
                      </div>
                  } */}
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div >
    );
  }
}
const mapStateToProps = state => ({
  profile: state.getIn(['auth', 'profile']),
  activity: state.getIn(['header', 'activity'])
});

const mapDispatchToProps = {

};


export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Header);

// export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js